module.exports = __webpack_public_path__ + "img/quest_icon_0029_check.5ebdb005.png";